<template>
  <base-chart-card
    color="#C2185B"
  >
    <template v-slot:heading>
      <base-bar-chart
        v-if="showChart"
        :chart-data="dataCollection"
        :options="options"
        style="max-height: 150px;"
      />
    </template>
    <template v-slot:reveal-actions>
      <v-tooltip bottom>
        <template v-slot:activator="{ attrs, on }">
          <v-btn
            v-bind="attrs"
            color="info"
            icon
            v-on="on"
          >
            <v-icon
              color="info"
            >
              mdi-refresh
            </v-icon>
          </v-btn>
        </template>

        <span>Refresh</span>
      </v-tooltip>

      <v-tooltip bottom>
        <template v-slot:activator="{ attrs, on }">
          <v-btn
            v-bind="attrs"
            light
            icon
            v-on="on"
          >
            <v-icon>mdi-pencil</v-icon>
          </v-btn>
        </template>

        <span>Change Date</span>
      </v-tooltip>
    </template>

    <h3 class="my-card-title-style">
      Monthly Work Completion
    </h3>

    <p class="my-card-subtitle-style">
      Work completion rate between dates<br>{{ lastMonthFirstDay }} to {{ lastMonthLastDay }}
    </p>
    <p
      v-if="noDataExist"
      class="alert-style"
    >
      No Data to Display.
    </p>
    <template v-slot:actions>
      <v-icon
        class="mr-1"
        small
        dense
      >
        mdi-clock-outline
      </v-icon>
      <span class="my-updation-text-style">Updated {{ lastUpdatedAt | diffHumans }}</span>
    </template>
  </base-chart-card>
</template>
<script>
  import moment from 'moment';
  import { isWorkCompletionDataExist } from 'src/helpers/chart-data-helper';

  export default {
    name: 'MonthlyWorkCompletion',
    filters: {
      diffHumans (val) {
        return moment(val).fromNow();
      },
      convertToLocal (stringDatetime) {
        return moment(stringDatetime).local().format('Do MMMM YYYY');
      },
    },
    data: () => ({
      label: 'Jobs Completed',
      lastMonthFirstDay: null,
      lastMonthLastDay: null,
      options: {
        responsive: true,
        maintainAspectRatio: false,
        legend: {
          labels: {
            fontColor: '#FBD6E3',
            fontsize: 14,
          },
        },
        scales: {
          yAxes: [{
            ticks: {
              fontColor: '#FBD6E3',
              stepSize: 50,
            },
          }],
          xAxes: [{
            scaleLabel: {
              display: true,
              labelString: 'My Sites',
              fontColor: '#FBD6E3',
            },
            ticks: {
              display: false,
              fontColor: '#FBD6E3',
            },
          }],
        },
      },
    }),
    computed: {
      chartData () {
        return this.$store.getters['dashboard/getMonthlyWorkCompletion'];
      },
      dataExist () {
        return this.chartData.length > 0;
      },
      showChart () {
        return Object.keys(this.dataCollection).length > 0;
      },
      dataCollection () {
        if (this.dataExist === false) {
          return {};
        }
        return this.generateDataCollection();
      },
      noDataExist () {
        const dataExist = isWorkCompletionDataExist(this.chartData);
        if (dataExist === true) {
          return false;
        }
        return true;
      },
      lastUpdatedAt () {
        return this.$store.getters['dashboard/getLastUpdatedAt'];
      },
    },
    mounted () {
      this.lastMonthFirstDay = moment().subtract(1, 'months').startOf('month').format('DD-MM-YYYY');
      this.lastMonthLastDay = moment().subtract(1, 'months').endOf('month').format('DD-MM-YYYY');
      this.fetchMonthlyWorkCompletionData();
    },
    methods: {
      fetchMonthlyWorkCompletionData () {
        this.$store.dispatch('dashboard/fetchMonthlyWorkCompletionData', {
          params: {
            from: moment().subtract(1, 'months').startOf('month').toISOString(),
            to: moment().subtract(1, 'months').endOf('month').toISOString(),
          },
        });
      },
      generateDataCollection () {
        const actionCount = [];
        const labels = [];
        for (const result of this.chartData) {
          labels.push(result.site.name);
          actionCount.push(result.completed_jobs);
        }
        return {
          labels: labels,
          datasets: [
            {
              data: actionCount,
              label: this.label,
              backgroundColor: '#FBD6E3',
              fill: false,
              barThickness: 20,
            },
          ],
        };
      },
    },
  };
</script>
<style scoped>
.alert-style {
  color: #C62828;
  text-align: center;
}
.my-card-title-style {
  color: #37474F;
  margin-left: 7px;
  margin-top: 10px;
  font-size: 18px;
}
.my-card-subtitle-style {
  color: #37474F;
  margin-left: 7px;
  margin-top: 7px;
  font-size: 14px;
}
.my-updation-text-style {
  color: #37474F;
  font-size: 12px;
}
</style>
